import { render, staticRenderFns } from "./pages7.vue?vue&type=template&id=23d01418&"
import script from "./pages7.vue?vue&type=script&lang=js&"
export * from "./pages7.vue?vue&type=script&lang=js&"
import style0 from "./pages7.vue?vue&type=style&index=0&id=23d01418&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports